import { i18n } from 'boot/i18n';

/**
 * How a hold task reads in the worklist: what is wrong, then what it is about and how much it
 * holds. The subject alone is what the open task shows, its impact being on the fix card. The name
 * comes from the caller, because a task stores ids only.
 *
 * @param {import('../../domain/model/HoldTask.types').HoldTask} hold
 * @param {string|null} subjectName
 * @returns {{title: string, caption: string, subject: string|null}}
 */
// eslint-disable-next-line import/prefer-default-export
export function presentHoldTask(hold, subjectName) {
  const impact = i18n.tc('billingItems.holdTask.textItems', hold.blockedCount, { count: hold.blockedCount });

  return {
    title: i18n.t(`billingItems.holdTask.${hold.holdType}.title`),
    caption: subjectName ? `${subjectName} · ${impact}` : impact,
    subject: subjectName,
  };
} // presentHoldTask()
